import { createApp } from 'vue'
import GlobalEvent from './services/event'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './assets/styles/index.scss'
import 'swiped-events'
import { setupAuthGuards } from './router/guards'
import '@fortawesome/fontawesome-free/css/all.css'
import { VUE_APP_GTM_ID } from './utils/env'

// Bus d'événements global accessible depuis tous les composants via window.Event
window.Event = new GlobalEvent()

// Configuration GTM
const tagManagerArgs = {
    gtmId: VUE_APP_GTM_ID,
}

// Initialisation GTM (équivalent de react-gtm-module)
if (tagManagerArgs.gtmId) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${tagManagerArgs.gtmId}`
    document.head.appendChild(script)
    
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    })
}

const app = createApp(App)

app.use(store)
app.use(router)

// Configurer les guards d'authentification
setupAuthGuards()

// L'authentification est initialisée automatiquement par le router guard
// (voir router/index.js beforeEach)

app.mount('#app')

